import Icon from '../components/Icon.vue'

Icon.register({
  'less-than': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M365.5 357.7c16.1 7.5 23 26.6 15.5 42.6l-13.6 29.1c-7.5 16.1-26.6 23-42.6 15.5l-306.3-142.8c-11.3-5.3-18.5-16.6-18.5-29v-34.2c0-11.3 8.3-24.2 18.5-29l306.5-142.9c16-7.5 35.1-0.5 42.5 15.5l13.5 29c7.5 16 0.5 35.1-15.5 42.5l-218.5 101.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/less-than.js
// module id = 1516
// module chunks = 0